module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('van-pull-refresh', {
    on: {
      "refresh": _vm.onRefresh
    },
    model: {
      value: (_vm.loadingFresh),
      callback: function($$v) {
        _vm.loadingFresh = $$v
      },
      expression: "loadingFresh"
    }
  }, [_c('van-list', {
    attrs: {
      "finished": _vm.noMore,
      "finished-text": "没有更多了"
    },
    on: {
      "load": _vm.onLoad
    },
    model: {
      value: (_vm.loadingMore),
      callback: function($$v) {
        _vm.loadingMore = $$v
      },
      expression: "loadingMore"
    }
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      staticClass: "row",
      on: {
        "click": function($event) {
          return _vm.gotuanShare(item.order_id)
        }
      }
    }, [_c('div', {
      staticClass: "goods-box"
    }, [_c('img', {
      staticClass: "goods-img",
      attrs: {
        "src": item.pic_url,
        "alt": ""
      }
    }), _vm._v(" "), (item.status == 1) ? _c('div', {
      staticClass: "goods-time"
    }, [_c('van-count-down', {
      attrs: {
        "time": (item.last_time + 1) * 1000,
        "format": "仅剩 DD天 HH : mm : ss"
      }
    })], 1) : _vm._e(), _vm._v(" "), (item.status == 2 || item.status == 3) ? _c('div', {
      staticClass: "past-due flex-center"
    }, [_c('img', {
      staticClass: "coupon-lose-img",
      attrs: {
        "src": require("../../../assets/newImg/icon-coupon-guoqi.png"),
        "alt": ""
      }
    }), _vm._v(">\n                    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "goods-name"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "row-price flex-between"
    }, [_c('div', {
      staticClass: "goods-detail flex-start"
    }, [_c('span', {
      staticClass: "goods-price"
    }, [_vm._v("¥"), _c('span', {
      staticClass: "goods-price-num"
    }, [_vm._v(_vm._s(item.pay_price))])]), _vm._v(" "), _c('span', {
      staticClass: "goods-price-thr gray-light"
    }, [_vm._v("¥" + _vm._s(item.order_price))]), _vm._v(" "), _c('span', {
      staticClass: "goods-tuan"
    }, [_vm._v("还差" + _vm._s(item.total_member_count - item.member_count) + "人成团")])])])])
  }), 0)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd837446","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/tuan/TuanList.vue
// module id = 2589
// module chunks = 0